import { useState, useEffect } from "react";
import { Modal, Spin } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { Modals } from "scripts/settings";
import Resources from "scripts/resources";
import API from "scripts/api";
import Icons from "scripts/icons";

const Component = ({ specialJobDescription }) => {
	const initialState = { phoneNumbers: [] };
	const [state, setState] = useState(initialState);
	const { phoneNumbers, visible } = state;
	const { hash } = useLocation();
	const navigate = useNavigate();

	const componentDidUpdate = () => {
		if (hash?.startsWith(`#${Modals.SPECIAL}`)) {
			setState((prevState) => ({
				...prevState,
				visible: true,
			}));
			API.contact()
				.then(({ data }) => {
					setState((prevState) => ({
						...prevState,
						...data,
						loaded: true,
					}));
				})

				.catch(() => {});
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Modal
			className="bk-modal-special"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.manageModal.specialAd}
		>
			{!!phoneNumbers.length ? (
				<>
					<div className="ad">{specialJobDescription}</div>
					<ul className="items">
						{phoneNumbers.map(({ number, type }, i) => (
							<li key={i}>
								<Link
									to={`tel:${number}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icons.Calling className="icon" />
									<span className="value">{number}</span>
									<span className="text">
										{type === "fax" ? Resources.faxUs : Resources.callUs}
									</span>
								</Link>
							</li>
						))}
					</ul>
				</>
			) : (
				<Spin />
			)}
		</Modal>
	);
};

export default connect((state) => {
	return {
		specialJobDescription: state.settings.specialJobDescription,
	};
})(Component);
